import { render, staticRenderFns } from "./zyjy.vue?vue&type=template&id=501e8973&scoped=true"
import script from "./zyjy.vue?vue&type=script&lang=js"
export * from "./zyjy.vue?vue&type=script&lang=js"
import style0 from "./zyjy.vue?vue&type=style&index=0&id=501e8973&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501e8973",
  null
  
)

export default component.exports